import React from 'react';
import {
	NavLink,
	Link
} from 'react-router-dom'


class ProjectInfoModal extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount(){
        // open and close modal
        let openModal = document.querySelector('.open-modal');
        let closeModal = document.querySelector('.close-modal');
        let modal = document.querySelector('.mole__side--modal');
   
        openModal.addEventListener('click', () => {
            modal.classList.add('is-showing');
        });
      
        closeModal.addEventListener('click', () => {
            modal.classList.remove('is-showing');
        });
        

        // close modal on Esc press
        window.addEventListener('keydown', (e) => {
            if(e.key == "Escape") {
                if(modal.classList.contains('is-showing')){
                    modal.classList.remove('is-showing');
                }
            }
        });


        // project info btn hide and show
        let wScrollY;
        let wHeight = window.innerHeight;
        let pInfoBtn = document.querySelector('.btn--projectInfo');
        let pInfoBtnShowPoint = document.querySelector('.mole__hero').offsetHeight;
        let pInfoBtnHidePoint = document.querySelector('.mole__related-projects').offsetTop;
        window.addEventListener('scroll', () => {
            wScrollY = window.scrollY;

            if(wScrollY > pInfoBtnShowPoint){
                console.log(pInfoBtnHidePoint.offsetTop);
                pInfoBtn.classList.remove('hidden');

                if(wScrollY > (pInfoBtnShowPoint + pInfoBtnShowPoint)){
                    pInfoBtn.classList.add('collapsed');
                }
                else{
                    pInfoBtn.classList.remove('collapsed');
                }

                if(wScrollY > (pInfoBtnHidePoint + wHeight + 250)){
                    pInfoBtn.classList.add('hidden');
                }
                else{
                    pInfoBtn.classList.remove('hidden');
                }
            }
            else{
                pInfoBtn.classList.add('hidden');
                pInfoBtn.classList.remove('collapsed');
            }
        });
    }

    render() {
        return (
            <React.Fragment>
                <a href="javascript:" class="mb-0 font-md d-inline-flex justify-content-center align-items-center open-modal btn--projectInfo hidden">
                   <span>Project Information</span>
                    <svg enable-background="new 0 0 50 50" version="1.1" viewBox="0 0 50 50" width="40px" height="40px" >
                        <circle cx="25" cy="25" fill="none" r="24" stroke="#000000" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/>
                        <rect fill="none" height="50" width="50"/>
                        <path d="M23.779,16.241c-0.216,0-0.357-0.144-0.357-0.359v-2.618c0-0.215,0.142-0.359,0.357-0.359h2.439  c0.215,0,0.359,0.144,0.359,0.359v2.618c0,0.215-0.145,0.359-0.359,0.359H23.779z M23.852,37.293c-0.215,0-0.358-0.143-0.358-0.358  V20.473c0-0.215,0.144-0.359,0.358-0.359h2.295c0.216,0,0.359,0.144,0.359,0.359v16.462c0,0.216-0.144,0.358-0.359,0.358H23.852z"/>
                    </svg>
                </a>
            
                <section className="mole__side--modal bg-general fixed mb-0">
                    <div className="main-container">
                        <div className="inner-container">
                            <h2 className="font-lg-head">Marmalade Lane</h2>
                            
                            <div className="grid">
                                <table className="--table-info">
                                    <tbody>
                                        <tr><td>Client</td><td>TOWN/ Trivselhus</td></tr>
                                        <tr><td>Location</td><td>Cambridge</td></tr>
                                        <tr><td>Sector</td><td><Link to={`${process.env.PUBLIC_URL}/project/housing`}>Housing</Link></td></tr>
                                        <tr><td>Size</td><td>4,300m<sup>2</sup></td></tr>
                                        <tr><td>Status</td><td>Completed 2018</td></tr>
                                        <tr><td>Photography</td><td>David Butler, Jim Stephenson and <br/>Jeremy Peters</td></tr>
                                    </tbody>
                                </table>

                                <article className="column-content desc">
                                    <p>Marmalade Lane is the first developer-led
                                    cohousing scheme in Cambridge, designed
                                    for developers TOWN and Trivselhus.
                                    The scheme advocates street-based
                                    development with 42 homes arranged in
                                    terraces and an apartment building, creating
                                    a new pedestrian focussed community ‘lane’.</p>

                                    <p>In common with other cohousing
                                    developments, shared spaces and facilities
                                    are integral to the development. Cars are
                                    relegated to the edge of the development,
                                    and the terraces enclose a large shared
                                    garden with an open aspect to the south.
                                    A central ‘common house’ faces onto the
                                    shared garden, a focal building for the
                                    cohousing community at the physical and
                                    social heart of the new community. </p>

                                    <p>The scheme is designed to exceptionally
                                    high environmental standards, using passive
                                    design principles and the houses are built
                                    using a pre-fabricated timber frame panel
                                    system, which is manufactured in Sweden.
                                    The apartment building and ‘common house’
                                    is built using cross-laminated timber. This
                                    ensures exceptional thermal efficiency,
                                    airtightness performance and a consistently
                                    high build quality.</p>
                                </article>
                            </div>

                            <div className="grid">
                                <div className="mt-auto"><a href="javascript:" className="link btn_prev close-modal c-hvr-white">Back</a></div>
                                <div><a href="javascript:" className="link font-md">To discuss your project <br/>Get in touch</a></div>
                            </div>
                        </div>
                    </div>
                </section>    
        
            </React.Fragment>
        );
    }
}
export default ProjectInfoModal;



// WEBPACK FOOTER //
// ./src/components/Projects/Details/ProjectInfoModal.js